<p class="extra-gordo">
  The following users have requested access to your community.
  Adding members to your community will consume paid membership seats.
</p>

<app-community-pending-requests-data-table
  [accessRequests$]="accessRequests$"
  (approve)="onAccessRequestApproval($event)">
</app-community-pending-requests-data-table>
